module.exports = __webpack_public_path__ + "assets/OrthicTriangleDetailed.e77afc076d3cb2c4fe420be3f5661e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/OrthicTriangleDetailed.png
// module id = 542
// module chunks = 0